import { CHANGE_LANGUAGE } from '../actions/types';

const initialState = {
  lang:'fa'
};

export default function(state = initialState, action) {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        lang: action.payload
      };
    // case GO_TO:
    //   return {
    //     ...state,
    //     routKey: action.payload
    //   };
    default:
      return state;
  }
}
